import { FLOLDER } from 'api';
import { getIn18Text } from 'api';
export { FLOLDER } from 'api';
export const FolderId2NameMap = {
    '1': getIn18Text('SHOUJIANXIANG'),
    '3': getIn18Text('FAJIANXIANG'),
    '2': getIn18Text('CAOGAOXIANG'),
    '17': getIn18Text('WEISHENHEWENJIAN'),
    '19': getIn18Text('YISHENHEWENJIAN'),
    '7': getIn18Text('GUANGGAOWENJIANJIA'),
    '5': getIn18Text('LAJIYOUJIAN1'),
    '6': getIn18Text('BINGDUWENJIAN'),
    '4': getIn18Text('YISHANCHUWENJIAN'),
    '18': getIn18Text('DINGYUEYOUJIAN'),
    '89': getIn18Text('GELIYOUJIAN'),
    '-1': getIn18Text('HONGQIYOUJIAN'),
    '-9': getIn18Text('RENWUYOUJIAN'),
    '-2': getIn18Text('QITAYOUJIAN'),
    '-3': getIn18Text('SHAOHOUCHULI'),
    '-199': getIn18Text('BIAOQIAN'),
};
export const FolderId2NameChineseMap = {
    '1': '收件箱',
    '3': '发件箱',
    '2': '草稿箱',
    '17': '待审核',
    '19': '已审核',
    '7': '广告邮件',
    '5': '垃圾邮件',
    '6': '病毒邮件',
    '4': '已删除',
    '18': '订阅邮件',
    '89': '隔离邮件',
    '-1': '红旗邮件',
    '-9': '任务邮件',
    '-2': '其他邮件',
    '-3': '稍后处理',
    '-199': '标签',
};
export const MAIL_FILL_RANG_NUM = 15;
export const MAIL_NOTICE_BAR_HEIGHT = 100;
export const MAX_MAILTOP_SUM = 20;
export const MAIL_CARD_BASE_HEIGHT = 63;
export const MAIL_CARD_ATTACH_HEIGHT = 32;
export const FOLDER_TREE_MAX_COUNT = +Infinity;
export const FOLDER_TREE_MAX_DEEP = 12;
export var MAIL_MENU_ITEM;
(function (MAIL_MENU_ITEM) {
    MAIL_MENU_ITEM["BACK"] = "BACK";
    MAIL_MENU_ITEM["RE_EDIT"] = "RE_EDIT";
    MAIL_MENU_ITEM["REPLAY"] = "REPLAY";
    MAIL_MENU_ITEM["REPLAY_ALL"] = "REPLAY_ALL";
    MAIL_MENU_ITEM["COMMENT"] = "COMMENT";
    MAIL_MENU_ITEM["FORWARD"] = "FORWARD";
    MAIL_MENU_ITEM["DELIVERY"] = "DELIVERY";
    MAIL_MENU_ITEM["FORWARD_BY_ATTACH"] = "FORWARD_BY_ATTACH";
    MAIL_MENU_ITEM["DEFER"] = "DEFER";
    MAIL_MENU_ITEM["RED_FLAG"] = "RED_FLAG";
    MAIL_MENU_ITEM["READ"] = "READ";
    MAIL_MENU_ITEM["TAG"] = "TAG";
    MAIL_MENU_ITEM["TOP"] = "TOP";
    MAIL_MENU_ITEM["MOVE"] = "MOVE";
    MAIL_MENU_ITEM["REPORT"] = "REPORT";
    MAIL_MENU_ITEM["REPORT_TRUST"] = "REPORT_TRUST";
    MAIL_MENU_ITEM["DELETE"] = "DELETE";
    MAIL_MENU_ITEM["DIRECT_DELETE"] = "DIRECT_DELETE";
    MAIL_MENU_ITEM["DELETE_WRAP"] = "DELETE_WRAP";
    MAIL_MENU_ITEM["SHARE"] = "SHARE";
    MAIL_MENU_ITEM["TRANSLATE"] = "TRANSLATE";
    MAIL_MENU_ITEM["OPEN_IN_WINDOW"] = "OPEN_IN_WINDOW";
    MAIL_MENU_ITEM["SEARCH_IN_CONTENT"] = "SEARCH_IN_CONTENT";
    MAIL_MENU_ITEM["SET_FROM_GROUP"] = "SET_FROM_GROUP";
    MAIL_MENU_ITEM["EXPORT"] = "EXPORT";
    MAIL_MENU_ITEM["ENCODING"] = "ENCODING";
    MAIL_MENU_ITEM["REPLAY_ATTACH"] = "REPLAY_ATTACH";
    MAIL_MENU_ITEM["REPLAY_ATTACH_ALL"] = "REPLAY_ATTACH_ALL";
    MAIL_MENU_ITEM["REPLAY_ALL_AS_NEW"] = "REPLAY_ALL_AS_NEW";
    MAIL_MENU_ITEM["MAIL_WITHDRAW"] = "MAIL_WITHDRAW";
    MAIL_MENU_ITEM["MAIL_WITHDRAW_RES"] = "MAIL_WITHDRAW_RES";
    MAIL_MENU_ITEM["PRINT_MAIL"] = "PRINT_MAIL";
    MAIL_MENU_ITEM["PRINT_MAIL_PREVIEW"] = "PRINT_MAIL_PREVIEW";
    MAIL_MENU_ITEM["LOCAL_MAIL_IMPORT"] = "LOCAL_MAIL_IMPORT";
    MAIL_MENU_ITEM["MARK"] = "MARK";
    MAIL_MENU_ITEM["CREATE_PERSONAL_GROUP"] = "CREATE_PERSONAL_GROUP";
    MAIL_MENU_ITEM["DISCUSSION"] = "DISCUSSION";
    MAIL_MENU_ITEM["EMAIL_HEADER"] = "EMAIL_HEADER";
    MAIL_MENU_ITEM["WMFOLLOW"] = "WMFOLLOW";
    MAIL_MENU_ITEM["WMFOLLOW_STATIC"] = "WMFOLLOW_STATIC";
    MAIL_MENU_ITEM["WM_UNFOLLOW_STATIC"] = "WM_UNFOLLOW_STATIC";
})(MAIL_MENU_ITEM || (MAIL_MENU_ITEM = {}));
export var MAIL_SORT_ITEM;
(function (MAIL_SORT_ITEM) {
    MAIL_SORT_ITEM["REDFLAG"] = "REDFLAG";
    MAIL_SORT_ITEM["UNREAD"] = "UNREAD";
    MAIL_SORT_ITEM["MY_CUSTOMER"] = "MY_CUSTOMER";
    MAIL_SORT_ITEM["ORDER_BY_DATE_DESC"] = "ALL";
    MAIL_SORT_ITEM["ORDER_BY_DATE_ASC"] = "ORDER_BY_DATE_ASC";
    MAIL_SORT_ITEM["ORDER_BY_SENDER_CAPITAL_DESC"] = "ORDER_BY_SENDER_CAPITAL_DESC";
    MAIL_SORT_ITEM["ORDER_BY_SENDER_CAPITAL_ASC"] = "ORDER_BY_SENDER_CAPITAL_ASC";
    MAIL_SORT_ITEM["ORDER_BY_RECEIVER_CAPITAL_DESC"] = "ORDER_BY_RECEIVER_CAPITAL_DESC";
    MAIL_SORT_ITEM["ORDER_BY_RECEIVER_CAPITAL_ASC"] = "ORDER_BY_RECEIVER_CAPITAL_ASC";
    MAIL_SORT_ITEM["ORDER_BY_SUBJECT_CAPITAL_DESC"] = "ORDER_BY_SUBJECT_CAPITAL_DESC";
    MAIL_SORT_ITEM["ORDER_BY_SUBJECT_CAPITAL_ASC"] = "ORDER_BY_SUBJECT_CAPITAL_ASC";
    MAIL_SORT_ITEM["ORDER_BY_SIZE_DESC"] = "ORDER_BY_SIZE_DESC";
    MAIL_SORT_ITEM["ORDER_BY_SIZE_ASC"] = "ORDER_BY_SIZE_ASC";
    MAIL_SORT_ITEM["DEFER"] = "DEFER";
    MAIL_SORT_ITEM["ON"] = "ON";
    MAIL_SORT_ITEM["SENT"] = "SENT";
    MAIL_SORT_ITEM["RECEIVED"] = "RECEIVED";
    MAIL_SORT_ITEM["ATTACHMENT"] = "ATTACHMENT";
    MAIL_SORT_ITEM["RECEIVER_READ"] = "RECEIVER_READ";
    MAIL_SORT_ITEM["RECEIVER_UNREAD"] = "RECEIVER_UNREAD";
    MAIL_SORT_ITEM["RECEIVER_READ_TAB"] = "RECEIVER_READ_TAB";
    MAIL_SORT_ITEM["RECEIVER_UNREAD_TAB"] = "RECEIVER_UNREAD_TAB";
})(MAIL_SORT_ITEM || (MAIL_SORT_ITEM = {}));
export const MAIL_DISCUSS_EXCLUDE_FOLDERS = [FLOLDER.SPAM, FLOLDER.ADVITISE, FLOLDER.DRAFT, FLOLDER.DELETED];
export const MAIL_STORE_REDUX_STATE = 'mailEntities';
export var LIST_MODEL;
(function (LIST_MODEL) {
    LIST_MODEL["INIT"] = "INIT";
    LIST_MODEL["SINGLE"] = "SINGLE";
    LIST_MODEL["MULTIPLE"] = "MULTIPE";
})(LIST_MODEL || (LIST_MODEL = {}));
export var TASK_MAIL_STATUS;
(function (TASK_MAIL_STATUS) {
    TASK_MAIL_STATUS[TASK_MAIL_STATUS["PROCESSING"] = 0] = "PROCESSING";
    TASK_MAIL_STATUS[TASK_MAIL_STATUS["COMPLETED"] = 1] = "COMPLETED";
    TASK_MAIL_STATUS[TASK_MAIL_STATUS["END"] = 2] = "END";
})(TASK_MAIL_STATUS || (TASK_MAIL_STATUS = {}));
export const allStr = getIn18Text('QUANBU');
export const preferredStr = getIn18Text('YOUXIAN');
export const redFlagStr = getIn18Text('JINHONGQI');
export const unReadStr = getIn18Text('JINWEIDU');
export const unRead3DayStr = getIn18Text('CHAOGUO3TIANWEID');
export const attachmentStr = getIn18Text('HANFUJIAN');
export const myCustomerStr = getIn18Text('JINWODEKEHU');
export const onStr = getIn18Text('JINXINGZHONG');
export const deferStr = getIn18Text('YIYUQI/JIN');
export const sendStr = getIn18Text('FAJIAN');
export const receiveStr = getIn18Text('SHOUJIAN');
export const colleagueStr = getIn18Text('colleague');
export const orderBySenderCapDescStr = getIn18Text('ORDER_BY_SENDER_CAPITAL_DESC');
export const orderBySenderCapAscStr = getIn18Text('ORDER_BY_SENDER_CAPITAL_ASC');
export const orderByReceiverCapDescStr = getIn18Text('ORDER_BY_RECEIVER_CAPITAL_DESC');
export const orderByReceiverCapAscStr = getIn18Text('ORDER_BY_RECEIVER_CAPITAL_ASC');
export const orderBySubjectCapDescStr = getIn18Text('ORDER_BY_SUBJECT_CAPITAL_DESC');
export const orderBySubjectCapAscStr = getIn18Text('ORDER_BY_SUBJECT_CAPITAL_ASC');
export const orderBySizeCapDescStr = getIn18Text('ORDER_BY_SIZE_DESC');
export const orderBySizeCapAscStr = getIn18Text('ORDER_BY_SIZE_ASC');
export const orderByDateAscStr = getIn18Text('ORDER_BY_DATE_ASC');
export const orderByDateDescStr = getIn18Text('ORDER_BY_DATE_DESC');
export const filterTabMap = {
    normal: [
        { type: 'ALL', title: orderByDateDescStr },
        { type: 'REDFLAG', title: redFlagStr },
        { type: 'UNREAD', title: unReadStr },
        { type: 'ORDER_BY_DATE_ASC', title: orderByDateAscStr },
        { type: 'ORDER_BY_SENDER_CAPITAL_DESC', title: orderBySenderCapDescStr },
        { type: 'ORDER_BY_SENDER_CAPITAL_ASC', title: orderBySenderCapAscStr },
        { type: 'ORDER_BY_RECEIVER_CAPITAL_DESC', title: orderByReceiverCapDescStr },
        { type: 'ORDER_BY_RECEIVER_CAPITAL_ASC', title: orderByReceiverCapAscStr },
        { type: 'ORDER_BY_SUBJECT_CAPITAL_DESC', title: orderBySubjectCapDescStr },
        { type: 'ORDER_BY_SUBJECT_CAPITAL_ASC', title: orderBySubjectCapAscStr },
        { type: 'ORDER_BY_SIZE_DESC', title: orderBySizeCapDescStr },
        { type: 'ORDER_BY_SIZE_ASC', title: orderBySizeCapAscStr },
    ],
    task: [
        { type: 'ALL', title: allStr },
        { type: 'ON', title: onStr },
    ],
    defer: [
        { type: 'ALL', title: allStr },
        { type: 'DEFER', title: deferStr },
    ],
    customer: [
        { type: 'ALL', title: allStr },
        { type: 'ME', title: getIn18Text('YUWO') },
        { type: 'COLLEAGUE', title: getIn18Text('YUTONGSHI') },
    ],
    subordinate: [
        { type: 'ALL', title: allStr },
        { type: 'SEND', title: sendStr },
        { type: 'RECEIVE', title: receiveStr },
    ],
    deleted: [
        { type: 'ALL', title: orderByDateDescStr },
        { type: 'ORDER_BY_DATE_ASC', title: orderByDateAscStr },
        { type: 'ORDER_BY_SENDER_CAPITAL_DESC', title: orderBySenderCapDescStr },
        { type: 'ORDER_BY_SENDER_CAPITAL_ASC', title: orderBySenderCapAscStr },
        { type: 'ORDER_BY_RECEIVER_CAPITAL_DESC', title: orderByReceiverCapDescStr },
        { type: 'ORDER_BY_RECEIVER_CAPITAL_ASC', title: orderByReceiverCapAscStr },
        { type: 'ORDER_BY_SUBJECT_CAPITAL_DESC', title: orderBySubjectCapDescStr },
        { type: 'ORDER_BY_SUBJECT_CAPITAL_ASC', title: orderBySubjectCapAscStr },
        { type: 'ORDER_BY_SIZE_DESC', title: orderBySizeCapDescStr },
        { type: 'ORDER_BY_SIZE_ASC', title: orderBySizeCapAscStr },
    ],
    spam: [
        { type: 'ALL', title: orderByDateDescStr },
        { type: 'ORDER_BY_DATE_ASC', title: orderByDateAscStr },
        { type: 'ORDER_BY_SENDER_CAPITAL_DESC', title: orderBySenderCapDescStr },
        { type: 'ORDER_BY_SENDER_CAPITAL_ASC', title: orderBySenderCapAscStr },
        { type: 'ORDER_BY_RECEIVER_CAPITAL_DESC', title: orderByReceiverCapDescStr },
        { type: 'ORDER_BY_RECEIVER_CAPITAL_ASC', title: orderByReceiverCapAscStr },
        { type: 'ORDER_BY_SUBJECT_CAPITAL_DESC', title: orderBySubjectCapDescStr },
        { type: 'ORDER_BY_SUBJECT_CAPITAL_ASC', title: orderBySubjectCapAscStr },
        { type: 'ORDER_BY_SIZE_DESC', title: orderBySizeCapDescStr },
        { type: 'ORDER_BY_SIZE_ASC', title: orderBySizeCapAscStr },
    ],
    waittingIssue: [
        { type: 'ALL', title: orderByDateDescStr },
        { type: 'ORDER_BY_DATE_ASC', title: orderByDateAscStr },
        { type: 'ORDER_BY_SENDER_CAPITAL_DESC', title: orderBySenderCapDescStr },
        { type: 'ORDER_BY_SENDER_CAPITAL_ASC', title: orderBySenderCapAscStr },
        { type: 'ORDER_BY_RECEIVER_CAPITAL_DESC', title: orderByReceiverCapDescStr },
        { type: 'ORDER_BY_RECEIVER_CAPITAL_ASC', title: orderByReceiverCapAscStr },
        { type: 'ORDER_BY_SUBJECT_CAPITAL_DESC', title: orderBySubjectCapDescStr },
        { type: 'ORDER_BY_SUBJECT_CAPITAL_ASC', title: orderBySubjectCapAscStr },
        { type: 'ORDER_BY_SIZE_DESC', title: orderBySizeCapDescStr },
        { type: 'ORDER_BY_SIZE_ASC', title: orderBySizeCapAscStr },
    ],
    readyIssue: [
        { type: 'ALL', title: orderByDateDescStr },
        { type: 'ORDER_BY_DATE_ASC', title: orderByDateAscStr },
        { type: 'ORDER_BY_SENDER_CAPITAL_DESC', title: orderBySenderCapDescStr },
        { type: 'ORDER_BY_SENDER_CAPITAL_ASC', title: orderBySenderCapAscStr },
        { type: 'ORDER_BY_RECEIVER_CAPITAL_DESC', title: orderByReceiverCapDescStr },
        { type: 'ORDER_BY_RECEIVER_CAPITAL_ASC', title: orderByReceiverCapAscStr },
        { type: 'ORDER_BY_SUBJECT_CAPITAL_DESC', title: orderBySubjectCapDescStr },
        { type: 'ORDER_BY_SUBJECT_CAPITAL_ASC', title: orderBySubjectCapAscStr },
        { type: 'ORDER_BY_SIZE_DESC', title: orderBySizeCapDescStr },
        { type: 'ORDER_BY_SIZE_ASC', title: orderBySizeCapAscStr },
    ],
    advitise: [
        { type: 'ALL', title: orderByDateDescStr },
        { type: 'ORDER_BY_DATE_ASC', title: orderByDateAscStr },
        { type: 'ORDER_BY_SENDER_CAPITAL_DESC', title: orderBySenderCapDescStr },
        { type: 'ORDER_BY_SENDER_CAPITAL_ASC', title: orderBySenderCapAscStr },
        { type: 'ORDER_BY_RECEIVER_CAPITAL_DESC', title: orderByReceiverCapDescStr },
        { type: 'ORDER_BY_RECEIVER_CAPITAL_ASC', title: orderByReceiverCapAscStr },
        { type: 'ORDER_BY_SUBJECT_CAPITAL_DESC', title: orderBySubjectCapDescStr },
        { type: 'ORDER_BY_SUBJECT_CAPITAL_ASC', title: orderBySubjectCapAscStr },
        { type: 'ORDER_BY_SIZE_DESC', title: orderBySizeCapDescStr },
        { type: 'ORDER_BY_SIZE_ASC', title: orderBySizeCapAscStr },
    ],
};
export var MAIL_SEARCH_FILTER;
(function (MAIL_SEARCH_FILTER) {
    MAIL_SEARCH_FILTER["folder"] = "\u6587\u4EF6\u5939";
    MAIL_SEARCH_FILTER["from"] = "\u53D1\u4EF6\u4EBA";
    MAIL_SEARCH_FILTER["sentDate"] = "\u65F6\u95F4\u8303\u56F4";
    MAIL_SEARCH_FILTER["attached"] = "\u6709\u65E0\u9644\u4EF6";
    MAIL_SEARCH_FILTER["read"] = "\u9605\u8BFB\u72B6\u6001";
})(MAIL_SEARCH_FILTER || (MAIL_SEARCH_FILTER = {}));
export const INIT_TASK_KEY = 'initTask';
export const INIT_TASK_TIME_KEY = 'initTaskTime';
export const INIT_STATE_KEY = 'initState';
export const MAIL_LIST_INIT_RANGE_COUNT = 30;
export const MAIL_LIST_MORE_RANGE_COUNT = 100;
export const FOLDER_EXPAND_ACCOUNT = 'FOLDER_ACCOUNT_EXPAND';
export const ERROR_REQUEST_CANCLE = 'ERROR_REQUEST_CANCLE';
export const ENCODING_MAP = {
    default: getIn18Text('MORENBIANMA'),
    GB2312: getIn18Text('GB2312'),
    Big5: getIn18Text('BIG5'),
    'UTF-8': getIn18Text('UTF-8'),
    'ISO-8859-1': getIn18Text('ISO-8859-1'),
    'EUC-JP': getIn18Text('EUC-JP'),
    Shift_JIS: getIn18Text('Shift-JIS'),
    'ISO-2022-KR': getIn18Text('IOS-2022-KR'),
};
export var MAIL_LIST_CHOOSE_TYPE;
(function (MAIL_LIST_CHOOSE_TYPE) {
    MAIL_LIST_CHOOSE_TYPE["ALL"] = "ALL";
    MAIL_LIST_CHOOSE_TYPE["EMPTY"] = "EMPTY";
    MAIL_LIST_CHOOSE_TYPE["UNREAD"] = "UNREAD";
    MAIL_LIST_CHOOSE_TYPE["READ"] = "READ";
})(MAIL_LIST_CHOOSE_TYPE || (MAIL_LIST_CHOOSE_TYPE = {}));
export const IMG_TYPES = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG', 'svg', 'SVG', 'gif', 'GIF'];
export const THREAD_MAIL_PAGE_SIZE = 50;
export const KEEP_PERIOS = 30;
export const MAIL_TAG_HOTKEY_LOCAL_KEY = 'MAIL_TAG_HOTKEY_LOCAL_KEY';
export const MAIL_TAG_GUIDE_LOCAL_KEY = 'MAIL_TAG_GUIDE_LOCAL_KEY';
export const MAIL_WRITE_GUIDE_LOCAL_KEY = 'MAIL_WRITE_GUIDE_LOCAL_KEY';
export const MAIL_WRITE_HOTKEY_LOCAL_KEY = 'MAIL_WRITE_HOTKEY_LOCAL_KEY';
export var MAIL_HOTKEY_MODULE_TYPE;
(function (MAIL_HOTKEY_MODULE_TYPE) {
    MAIL_HOTKEY_MODULE_TYPE["MAIL_LIST"] = "MAIL_LIST";
    MAIL_HOTKEY_MODULE_TYPE["MAIL_DETAIL"] = "MAIL_DETAIL";
    MAIL_HOTKEY_MODULE_TYPE["MAIL_WRITE"] = "MAIL_WRITE";
    MAIL_HOTKEY_MODULE_TYPE["MAIL_TAG"] = "MAIL_TAG";
    MAIL_HOTKEY_MODULE_TYPE["MAIL_LIST_CSTOM"] = "MAIL_LIST_CSTOM";
    MAIL_HOTKEY_MODULE_TYPE["MAIL_DETAIL_CSTOM"] = "MAIL_DETAIL_CSTOM";
    MAIL_HOTKEY_MODULE_TYPE["MAIL_BOX"] = "MAIL_BOX";
})(MAIL_HOTKEY_MODULE_TYPE || (MAIL_HOTKEY_MODULE_TYPE = {}));
export const MAIL_MAILLIST_TAB_AVTIVE_KEY = 'MAIL_MAILLIST_TAB_AVTIVE_KEY';
export const MAIL_RELATED_MAILLIST_TAB_AVTIVE_KEY = 'MAIL_RELATED_MAILLIST_TAB_AVTIVE_KEY';
export const PIN_KEY = 'LOCAL_RD_MAIL_PIN';
export const MAIL_ALL_FOLDER_SORT_KEY = 'MAIL_ALL_FOLDER_SORT_KEY';
export const MAIL_FOLDER_SELECTED_LOCAL_KEY = 'MAIL_FOLDER_SELECTED_LOCAL_KEY';
export const MAIL_CROSS_ROOM_ERROR_TIP_LOCAL_KEY = 'MAIL_CROSS_ROOM_ERROR_TIP_LOCAL_KEY';
export const MAIL_PLUS_CUSTOMER_GROUP_LATEST_CONTACT = 'LatestContact';
export const MAIL_PLUS_CUSTOMER_GROUP_MONITOR = 'Monitor';
export const MAIL_PLUS_CUSTOMER_GROUP_FAVORITE = 'Favorite';
export const MAIL_TAG_SYSTEM_MAP = {
    __delivery__: '接受分发邮件',
    __deliveryrecord__: '已分发的邮件',
};
export const MAIL_TAG_QUERY_MAP = {
    __delivery__: 4,
    __deliveryrecord__: 3,
};
export const QUERY2MAIL_TAG_MAP = {
    4: '__delivery__',
    3: '__deliveryrecord__',
};
const DAY_MS = 24 * 60 * 60 * 1000;
export const MAIL_RECALL_LEVELS = {
    v1: 15 * DAY_MS,
    v2: 30 * DAY_MS,
};
export const MAIL_RECALL_MAX_DAY_LEVEL_MAP = {
    sirius: 'v2',
    navigateVersion: 'v2',
    ultimate: 'v1',
    free: 'v1',
    education: 'v1',
    standard_1g: 'v1',
    standard_3g: 'v1',
    others: 'v1',
};
